import React from 'react';
import { Link } from '@tanstack/react-router';

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/collapsible';
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from '@/components/ui/sidebar';
import { ILink } from './types';

interface NavMainProps {
  items: ILink[];
}

const NavMain: React.FC<NavMainProps> = ({ items }) => (
  <SidebarGroup>
    <SidebarMenu>
      {items.map(({ label, icon: Icon, disabled, items, ...props }) =>
        items?.length ? (
          <Collapsible key={label} asChild open className="group/collapsible">
            <SidebarMenuItem>
              <CollapsibleTrigger asChild>
                {disabled ? (
                  <SidebarGroupLabel className="gap-2 text-sm text-sidebar-foreground font-normal cursor-default">
                    {Icon && <Icon />}
                    <span>{label}</span>
                  </SidebarGroupLabel>
                ) : (
                  <Link {...props} activeOptions={{ exact: true }}>
                    {({ isActive }) => (
                      <SidebarMenuButton tooltip={label} isActive={isActive}>
                        {Icon && <Icon />}
                        <span>{label}</span>
                      </SidebarMenuButton>
                    )}
                  </Link>
                )}
              </CollapsibleTrigger>
              <CollapsibleContent>
                <SidebarMenuSub>
                  {items?.map(({ label, icon: Icon, ...props }) => (
                    <SidebarMenuSubItem key={label}>
                      <Link {...props} activeOptions={{ exact: true }}>
                        {({ isActive }) => (
                          <SidebarMenuSubButton asChild isActive={isActive}>
                            <span>
                              {Icon && <Icon />}
                              {label}
                            </span>
                          </SidebarMenuSubButton>
                        )}
                      </Link>
                    </SidebarMenuSubItem>
                  ))}
                </SidebarMenuSub>
              </CollapsibleContent>
            </SidebarMenuItem>
          </Collapsible>
        ) : (
          <SidebarMenuItem key={label}>
            <Link {...props} activeOptions={{ exact: true }}>
              {({ isActive }) => (
                <SidebarMenuButton asChild isActive={isActive}>
                  <span>
                    {Icon && <Icon />}
                    {label}
                  </span>
                </SidebarMenuButton>
              )}
            </Link>
          </SidebarMenuItem>
        ),
      )}
    </SidebarMenu>
  </SidebarGroup>
);

export default NavMain;
